export const getPayrollsColumns = () => {
    return [
        {
            key: "pay_day",
            headerName: "Payday",
        },
        {
            key: "pay_period",
            headerName: "Pay Period",
        },
        {
            key: "processing_period",
            headerName: "Processing Period",
        },
        {
            key: "_processing_period",
            headerName: "Processing Period",
        },
        {
            key: "status",
            headerName: "Status",
            renderValue: (row) => {
                return (
                    <button className='draft-button'>{row?.status}</button>
                )
            }
        },
        {
            key: "voided",
            headerName: "Voided",
            renderValue: (row) => {
                return (
                    <button className='not-void-button'>{row?.voided}</button>
                )
            }
        },
    ]
}

export const timeKeepingColumns = () => {
    return [
        {
            key: "status",
            headerName: "Status",
        },
        {
            key: "shift_day",
            headerName: "Shift Date",
        },
        {
            key: "workplace",
            headerName: "Workplace",
        },
        {
            key: "clockin",
            headerName: "Clock in",
            renderValue: () => {
                return (
                    <div>
                        <span>12:00AM,</span>
                        <br />
                        <span>13 Feb 25</span>
                    </div>
                )
            }
        },
        {
            key: "clockout",
            headerName: "Clock out",
            renderValue: () => {
                return (
                    <div>
                        <span>12:00AM,</span>
                        <br />
                        <span>13 Feb 25</span>
                    </div>
                )
            }
        },
        {
            key: "total_hours",
            headerName: "Total Hours",
        },
        {
            key: "paid_hours",
            headerName: "Paid Hours",
        },
        {
            key: "paid_breaks",
            headerName: "Paid breaks",
        },
        {
            key: "unpaid_breaks",
            headerName: "Unpaid breaks",
        },
    ]
}